import { Paper, styled } from '@mui/material'

export const GroupedReviewStatusContainer = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(1),
}))
